
export function chunkItems<T> (items: T[], chunkSize: number = 512): T[][] {
  if(chunkSize <= 0) {throw new Error('ChunkSize must be greater then 0!')}
  return  items.reduce((chunks: T[][], item: T, index) => {
    const chunk = Math.floor(index / chunkSize);
    chunks[chunk] = ([] as T[]).concat(chunks[chunk] || [], item);
    return chunks;
  }, []);
}
